import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display", "editForm", "inputContainer"]
  static values = { editPlaceholder: String, firstPlaceholder: String }

  editMode() {
    this.displayTarget.classList.add('d-none')
    this.editFormTarget.classList.remove('d-none')
    this.createInputField()
  }

  cancelEdit() {
    this.editFormTarget.classList.add('d-none')
    this.displayTarget.classList.remove('d-none')
    this.inputContainerTarget.innerHTML = ''
  }

  createInputField() {
    const isFirstConfig = this.displayTarget.textContent.includes('Nenhuma') ||
                          this.displayTarget.textContent.includes('No API key')

    const placeholder = isFirstConfig ? this.firstPlaceholderValue : this.editPlaceholderValue

    this.inputContainerTarget.innerHTML = `
      <input type="text"
             name="ats_company[coodesh_api_key]"
             id="ats_company_coodesh_api_key"
             class="form-control"
             placeholder="${placeholder}"
             value="">
    `

    this.inputContainerTarget.querySelector('input').focus()
  }
}
